import { Chakra } from "@airhelp/react-ui-components";
import Heading from "components/Heading";
import type { ReactStoryblokComponent } from "modules/storyblok/types";
import type { HeadingAdapterProps } from "./Heading.d";
import headingVarinats from "./Heading.config";

const { useBreakpointValue } = Chakra;

const HeadingAdapter = ({
  blok: { text, type: variant, color, mbDesktop, mbMobile },
}: ReactStoryblokComponent<HeadingAdapterProps>) => {
  const marginBottom = useBreakpointValue({ base: mbMobile, lg: mbDesktop });

  return (
    <Heading
      as={`h${variant}`}
      text={text}
      marginBottom={marginBottom}
      variant={headingVarinats[variant]}
      color={color}
    />
  );
};

export default HeadingAdapter;
